import './PromptFlowAction.scss';

import React, { FC } from 'react';
import { PromptFlow, TargetAction } from 'models/PromptFlow';
import { Button, Card, } from 'react-bootstrap';

import ConversationTemplate from '../ConversationTemplate/ConversationTemplate';


interface PromptFlowActionProps {
  promptFlow: PromptFlow
  onExecuteAction: (action: PromptFlow) => void;
}

const PromptFlowAction: FC<PromptFlowActionProps> = ({promptFlow, onExecuteAction}) => {
  const getTargetClass = (targetAction: TargetAction) =>{
    switch (targetAction) {
      case TargetAction.GenerateArticleContent:
        return 'bi bi-file-text';
      case TargetAction.GenerateArticleTitle:
        return 'bi bi-type-h1';
      case TargetAction.GenerateArticleOutline:
        return 'bi bi-list-nested'
      case TargetAction.GenerateFacebookPost:
        return 'bi bi-facebook';
      case TargetAction.GenerateLinkedInPost:
        return 'bi bi-linkedin';
      case TargetAction.GenerateTwitterPost:
        return 'bi bi-twitter-x';
      default:
        return '';
    }
  };
 
  return (
  <Card key={`pf-action-id-${promptFlow.id}`} className="my-2 box-shadow">
    <Card.Header title={promptFlow.targetAction}>
        <i className={getTargetClass(promptFlow.targetAction)} />
        {" "}{promptFlow.name}
    </Card.Header>
    <Card.Body>  
      <Card.Text dangerouslySetInnerHTML={{ __html : promptFlow.metaDescription! }} />
      <div className='float-right'>
        <ConversationTemplate conversation={promptFlow.conversationTemplate} type="Template" parent={promptFlow} onExecute={onExecuteAction} />
        <Button variant='primary' onClick={() => { onExecuteAction(promptFlow) }}>
          Run
        </Button>
      </div>
    </Card.Body>
  </Card>
);

}

export default PromptFlowAction;
